import { useEffect } from "react";

export default function useOutsideClick<T extends HTMLElement>(
  ref: React.RefObject<T>,
  handler: (event: MouseEvent | TouchEvent) => void,
  ignoreSelector?: string, // optional selector to ignore (e.g. "[data-menu-trigger]")
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node | null;
      if (!ref.current || !target) return;

      // if click happened inside the ref => ignore
      if (ref.current.contains(target)) return;

      // if ignoreSelector is provided and click is on/inside an ignored element => ignore
      if (
        ignoreSelector &&
        (target as Element).closest &&
        (target as Element).closest(ignoreSelector)
      ) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, ignoreSelector]);
}
